import * as layout from '../layout.js';

window.addEventListener('load', () => {
    layout.initStickyNavbar();
})